/**
 * @generated SignedSource<<9df9e3399167a75e2100ee1ed092af6d>>
 * @relayHash 836d970ab4138824b107fbfbee73eda2
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-finding/424.0.0-2023-08-04T08:32:19.033Z/SharedContactDealerWrapperRefetchQuery

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "DKK" | "EUR" | "GBP" | "JPY" | "MXN" | "NOK" | "SEK" | "USD" | "%future added value";
export type SharedContactDealerWrapperRefetchQuery$variables = {
  fetchUser: boolean;
  isClient: boolean;
  itemId: string;
  itemQuantity?: number | null;
  userCountryCode?: string | null;
  userId: string;
  userZipCode?: string | null;
};
export type SharedContactDealerWrapperRefetchQuery$data = {
  readonly viewer: {
    readonly relevantShipping: {
      readonly quoteRequestStatus: string | null;
      readonly shipment: {
        readonly shippingAddress: {
          readonly displayCityStateCountry: string | null;
        } | null;
      } | null;
      readonly shipmentQuote: {
        readonly buyerServiceMethodDisplay: string | null;
        readonly handlingTimeDisplay: string | null;
        readonly serviceMethod: {
          readonly serviceMethodType: string | null;
          readonly serviceType: string | null;
        } | null;
        readonly showQuoteAsPending: boolean | null;
        readonly subTotalAmount: {
          readonly convertedAmountList: ReadonlyArray<{
            readonly amount: number | null;
            readonly currency: Currency | null;
          } | null> | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingInfoLink_shipmentQuote">;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PdpRespSidebarBlurbShipping_viewer" | "PdpSharedShippingHolidayDelivery_viewer" | "PdpSharedShippingInfoLink_viewer">;
  };
};
export type SharedContactDealerWrapperRefetchQuery = {
  response: SharedContactDealerWrapperRefetchQuery$data;
  variables: SharedContactDealerWrapperRefetchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fetchUser"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isClient"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "itemQuantity"
},
v4 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userCountryCode"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "userId"
},
v6 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "userZipCode"
},
v7 = {
  "kind": "Variable",
  "name": "buyerId",
  "variableName": "userId"
},
v8 = {
  "kind": "Variable",
  "name": "itemId",
  "variableName": "itemId"
},
v9 = [
  (v7/*: any*/),
  {
    "kind": "Variable",
    "name": "countryCode",
    "variableName": "userCountryCode"
  },
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "quantity",
    "variableName": "itemQuantity"
  },
  {
    "kind": "Variable",
    "name": "zipCode",
    "variableName": "userZipCode"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quoteRequestStatus",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "displayShort",
      "value": true
    }
  ],
  "kind": "ScalarField",
  "name": "handlingTimeDisplay",
  "storageKey": "handlingTimeDisplay(displayShort:true)"
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "amount",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "concreteType": "FinancialAmount",
  "kind": "LinkedField",
  "name": "subTotalAmount",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ConvertedAmountList",
      "kind": "LinkedField",
      "name": "convertedAmountList",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "currency",
          "storageKey": null
        },
        (v12/*: any*/)
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "buyerServiceMethodDisplay",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showQuoteAsPending",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceType",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceMethodType",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "displayCityStateCountry",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "serviceId",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SharedContactDealerWrapperRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpRespSidebarBlurbShipping_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingHolidayDelivery_viewer"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PdpSharedShippingInfoLink_viewer"
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "relevantShipping",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PdpSharedShippingInfoLink_shipmentQuote"
                  },
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "kind": "LinkedField",
                    "name": "serviceMethod",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "shippingAddress",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "SharedContactDealerWrapperRefetchQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": "pdpHolidayShippingFeatureFlag",
            "args": [
              {
                "kind": "Literal",
                "name": "featureName",
                "value": "HOLIDAY_SHIPPING"
              }
            ],
            "kind": "ScalarField",
            "name": "isEnabledByLocale",
            "storageKey": "isEnabledByLocale(featureName:\"HOLIDAY_SHIPPING\")"
          },
          {
            "condition": "isClient",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "country",
                    "variableName": "userCountryCode"
                  },
                  (v8/*: any*/)
                ],
                "concreteType": "TransactionWarningQueryType",
                "kind": "LinkedField",
                "name": "transactionWarnings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasRestrictedMaterials",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isCheckoutBlocked",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v9/*: any*/),
                "concreteType": "RelevantShippingInfo",
                "kind": "LinkedField",
                "name": "relevantShipping",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentQuote",
                    "kind": "LinkedField",
                    "name": "shipmentQuotes",
                    "plural": true,
                    "selections": [
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "isComplimentary",
                        "storageKey": null
                      },
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "FinancialAmount",
                        "kind": "LinkedField",
                        "name": "totalAmount",
                        "plural": false,
                        "selections": [
                          (v12/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ShipmentServiceMethod",
                        "kind": "LinkedField",
                        "name": "serviceMethod",
                        "plural": false,
                        "selections": [
                          (v16/*: any*/),
                          (v17/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Region",
                            "kind": "LinkedField",
                            "name": "region",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "code",
                                "storageKey": null
                              },
                              (v20/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v20/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ]
          },
          {
            "condition": "fetchUser",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "alias": null,
                "args": [
                  (v7/*: any*/),
                  (v8/*: any*/)
                ],
                "concreteType": "Conversation",
                "kind": "LinkedField",
                "name": "buyerItemConversation",
                "plural": false,
                "selections": [
                  (v19/*: any*/),
                  (v20/*: any*/)
                ],
                "storageKey": null
              }
            ]
          },
          {
            "alias": null,
            "args": (v9/*: any*/),
            "concreteType": "RelevantShippingInfo",
            "kind": "LinkedField",
            "name": "relevantShipping",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "ShipmentQuote",
                "kind": "LinkedField",
                "name": "shipmentQuote",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ShipmentServiceMethod",
                    "kind": "LinkedField",
                    "name": "serviceMethod",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Shipment",
                "kind": "LinkedField",
                "name": "shipment",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Address",
                    "kind": "LinkedField",
                    "name": "shippingAddress",
                    "plural": false,
                    "selections": [
                      (v18/*: any*/),
                      (v20/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v20/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-finding/424.0.0-2023-08-04T08:32:19.033Z/SharedContactDealerWrapperRefetchQuery",
    "metadata": {},
    "name": "SharedContactDealerWrapperRefetchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bc7abba42df321a5141b3c3542101555";

export default node;
